module.exports = __webpack_public_path__ + "media/images/featuredon_technically-0c23881a.jpeg";